import { usePathname, useSearchParams } from "next/navigation";

// components
import Select from "@/shared/Select";

// helpers
import useCurrency from "@/hooks/useCurrency";
import global from "@/api/query/global";

// interfaces
import { TCurrencies, TRegion } from "./IHeaderRegionCurrencyDropdownContent";

// assets
import styles from "@/assets/styles/components/header-region-currency-dropdown.module.scss";


interface IHeaderRegionCurrencyDropdownContent {
  currenciesOptions: TCurrencies[];
  currency: TCurrencies;
  region: TRegion;
}

const HeaderRegionCurrencyDropdownContent = (props: IHeaderRegionCurrencyDropdownContent) => {
  const { currenciesOptions, region, currency } = props;
  
  const pathname = usePathname()
  const searchParams = useSearchParams();

  const [_, onChangeCurrency] = useCurrency();

  const { data: regions } = global.useGeographicRegion();
  
  const regionOptions = (regions || []).map(item => ({
    label: item.name,
    value: `/${item.code}`,
    code: item.code,
  }));
  const selectedCurrency = currenciesOptions.find(item => item.value === currency?.value);
  const selectedRegion = regionOptions.find((regionItem) => regionItem.code === region?.code) || regionOptions[0];

  const handleChangeCurrency = (e: unknown) => {
    const event = e as TCurrencies
    
    if (event?.value !== currency?.value) {
      onChangeCurrency(event?.currencyObj);
    }
  };

  const handleChangeRegion = (e: unknown) => {
    const event = e as typeof regionOptions[0];
    const currentUrl = pathname.replace(/^\/(uk|aus)/, "") || "/";

    window.location.href = `${process.env.NEXT_PUBLIC_LOLIVE_URL}${event?.value}${currentUrl}${searchParams.toString() ? `?${searchParams.toString()}` : ""}`
  }

  // render
  return (
    <div className={styles["locl-header-region-currency-dropdown__dropdown__body"]} data-testid="locl-header-region-currency-dropdown-content">
      <Select
        name="region"
        value={selectedRegion}
        onChange={handleChangeRegion}
        options={regionOptions}
        className={styles["locl-header-region-currency-dropdown__dropdown__select"]}
        aria-label="locl-header-region-currency-dropdown-region-select"
        menuListTestId="locl-header-region-currency-dropdown-region-select-list"
        label="Region"
        fullWidth
      />
      <Select
        name="currency"
        value={selectedCurrency}
        onChange={handleChangeCurrency}
        options={currenciesOptions}
        className={styles["locl-header-region-currency-dropdown__dropdown__select"]}
        aria-label="locl-header-region-currency-dropdown-currency-select"
        menuListTestId="locl-header-region-currency-dropdown-currency-select-list"
        label="Currency"
        fullWidth
      />
    </div>
  )
}

export default HeaderRegionCurrencyDropdownContent;
